import { render, staticRenderFns } from "./TopSpacesTable.vue?vue&type=template&id=1c26105e&scoped=true&"
import script from "./TopSpacesTable.vue?vue&type=script&lang=js&"
export * from "./TopSpacesTable.vue?vue&type=script&lang=js&"
import style0 from "./TopSpacesTable.vue?vue&type=style&index=0&id=1c26105e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c26105e",
  null
  
)

export default component.exports